const initState = {
    index: '/',
    inputValue: '',
    list: []
};
export default (state = initState, action) => {
    if (action.type === 'change_input_value') {
        const newState = JSON.parse(JSON.stringify(state));
        newState.inputValue = action.value;
        return newState;
    }

    if (action.type === "add_todo_item") {
        const newState = JSON.parse(JSON.stringify(state));
        newState.list.push(newState.inputValue);
        newState.inputValue = '';
        return newState;
    }

    //点击删除
    if (action.type === 'delete_todo_item') {
        const newState = JSON.parse(JSON.stringify(state));
        newState.list.splice(action.index, 1);
        return newState;
    }
    // 修改下标
    if (action.type === 'change_index') {
        const newState = JSON.parse(JSON.stringify(state));
        newState.index = action.value;
        return newState;
    }
    return state;
}